import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";
import BlocksAccordion from "./blocks/BlocksAccordion.js";
import NewsLoader from "./components/NewsLoader.js";
import TableDownloader from "./components/TableDownloader.js";
import BlocksTabs from "./blocks/BlocksTabs.js";
import OnScrollAnimations from "./components/OnScrollAnimations.js";
import { initMapLightboxes } from "../helpers/helpers.js";

export default class PageDefault extends PageCommon {
  constructor() {
    super();
    this.isHp = false;
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageDefault - Hello world");

    this.initSwiperNews();
    this.initSwiperAwards();
    this.initAccordions();
    this.initNewsLoadMore();
    this.initTableDownload();
    this.initTabs();
    this.initBlocksOnScrollAnimations();
    this.initGMap();
    initMapLightboxes();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  get isHomepage() {
    return this.isHp;
  }

  set isHomepage(bool) {
    this.isHp = bool;
  }  

  initGMap() {
    return;

    const maps = document.querySelectorAll(".js-gmap");
    if ( ! maps.length > 0 ) return;

    //maps.forEach((map, i) => {
    //  const map = new google.maps.Map(document.getElementById('map-1'), {
    //    zoom: 16,
    //    center: {
    //      lat: 45.0667039,
    //      lng: 7.6686804
    //    },
    //    styles: this.style,
    //    zoomControl: false,
    //    mapTypeControl: false,
    //    streetViewControl: false
    //  });

    //  const marker = new google.maps.Marker({
    //    position: map.getCenter(),
    //    icon: '/assets/pin-map-map.png',
    //    map: map
    //  });
    //});    
  }

  initAccordions() {
    const blocksAccordion = new BlocksAccordion();
    blocksAccordion.init();
  }

  initNewsLoadMore() {
    const newsLoader = new NewsLoader();
    newsLoader.init();
  }

  initTableDownload() {
    const tableDownloader = new TableDownloader();
    tableDownloader.init();
  }

  initTabs() {
    const blocksTabs = new BlocksTabs();
    blocksTabs.init();
  }

  initBlocksOnScrollAnimations() {
    const onScrollAnimations = new OnScrollAnimations();
    onScrollAnimations.init();
  }

  initSwiperNews() {
    const newsBlocks = this.page.querySelectorAll(".js-swiper-articles");
    newsBlocks?.forEach(news => {
      const swiper = new Swiper(news, {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: news.querySelector(".swiper-pagination")
        },
        navigation: {
          nextEl: news.querySelector(".swiper-button-next"),
          prevEl: news.querySelector(".swiper-button-prev")
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 0
          }
        }
      });
    });
  }

  initSwiperAwards() {
    const awards = this.page.querySelectorAll(".js-swiper-awards");
    awards?.forEach(award => {
      const swiper = new Swiper(award, {
        slidesPerView: 3.125,
        spaceBetween: 12,
        freeMode: true,
        grabCursor: true,
        autoplay: true,
        centeredSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 7,
            spaceBetween: 24
          }
        }
      });
    });
  }
}